@if (headerWeight === 1) {
  <h2
    id="{{ chapterId }}"
    role="button"
    tabindex="0"
    (click)="userGuideService.anchorChapter(chapterId)"
    (keydown.enter)="userGuideService.anchorChapter(chapterId)"
  >
    <payee-icon
      height="16px"
      width="16px"
      name="link-outline"
    ></payee-icon>
    <span>{{ chapterId }}. {{ chapterName }}</span>
  </h2>
}

@if (headerWeight === 2) {
  <h3
    id="{{ chapterId }}"
    role="button"
    tabindex="0"
    (click)="userGuideService.anchorChapter(chapterId)"
    (keydown.enter)="userGuideService.anchorChapter(chapterId)"
  >
    <payee-icon
      height="16px"
      width="16px"
      name="link-outline"
    ></payee-icon>
    <span>{{ chapterId }}. {{ chapterName }}</span>
  </h3>
}

@if (headerWeight === 3) {
  <h4 id="{{ chapterId }}">
    <payee-icon
      height="16px"
      width="16px"
      name="link-outline"
    ></payee-icon>
    <span>{{ chapterId }}. {{ chapterName }}</span>
  </h4>
}

@if (headerWeight > 3) {
  <h5 id="{{ chapterId }}">{{ chapterId }} {{ chapterName }}</h5>
}
